import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';

export default function PartnerBrief({ piece }) {
  const { updateContentPiece, removeContentPiece } = useApp();
  const [activeTab, setActiveTab] = useState('finished');
  const [copied,    setCopied]    = useState(false);

  function copy() {
    const text = activeTab === 'finished' ? piece.finished_post : piece.talking_points;
    navigator.clipboard.writeText(text || '').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  async function approve() {
    await updateContentPiece(piece.id, { status:'approved' }).catch(console.error);
  }

  async function remove() {
    if (!confirm('Remove this brief?')) return;
    await removeContentPiece(piece.id).catch(console.error);
  }

  return (
    <div className="gen-piece" style={{ borderColor:'var(--pb)' }}>
      <div className="gp-head">
        <div className="gp-ch-dot" style={{ background:'#f57f17' }} />
        <div className="gp-ch-name">🤝 Partner Brief</div>
        <span className="gp-status gs-draft" style={{ marginLeft:'auto' }}>{piece.status}</span>
      </div>

      <div className="pb-tabs">
        <button className={`pb-tab ${activeTab === 'finished' ? 'active' : ''}`} onClick={() => setActiveTab('finished')}>
          Finished Post
        </button>
        <button className={`pb-tab ${activeTab === 'talking'  ? 'active' : ''}`} onClick={() => setActiveTab('talking')}>
          Talking Points
        </button>
      </div>

      <div className="pb-content">
        <pre style={{ fontFamily:'inherit', fontSize:12.5, lineHeight:1.7, whiteSpace:'pre-wrap', color:'var(--espresso)' }}>
          {activeTab === 'finished' ? (piece.finished_post || piece.content) : piece.talking_points}
        </pre>
      </div>

      <div className="gp-foot">
        <button className="btn btn-green btn-xs" onClick={approve}>✓ Approve</button>
        <button className="btn btn-outline btn-xs" onClick={copy}>{copied ? '✓ Copied!' : '📋 Copy'}</button>
        <button className="btn btn-danger btn-xs" onClick={remove}>✕</button>
      </div>
    </div>
  );
}
